import React, { useEffect, useState } from "react";
import { Copy, Trash2, Lock, Globe, FileText } from "lucide-react";
import { toast } from "sonner";
import api, { mediaUrl } from "../../lib/api";
import { UploadButton } from "../cms/UploadButton";

export const MediaLibrary = () => {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/media").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const copy = (m) => { navigator.clipboard?.writeText(m.url); toast.success("Link copied — paste it into any image/video field."); };
  const del = async (m) => { if (!window.confirm(`Remove ${m.filename}?`)) return; await api.delete(`/admin/media/${m.id}`); load(); };
  const togglePublic = async (m) => { await api.patch(`/admin/media/${m.id}`, { public: !m.public }); load(); };

  return (
    <div data-testid="admin-media-library">
      <div className="card-surface p-6 flex flex-wrap items-center justify-between gap-4">
        <div>
          <h3 className="font-display text-2xl font-semibold text-brand-ink">Media Library</h3>
          <p className="text-sm text-brand-muted">Upload photos, videos (MP4) and PDFs. Videos are private to members by default.</p>
        </div>
        <div className="flex gap-2 flex-wrap">
          <UploadButton accept="image/*" isPublic label="Upload Image" onUploaded={load} testid="media-upload-image" />
          <UploadButton accept="video/*" label="Upload Video" onUploaded={load} testid="media-upload-video" />
          <UploadButton accept="application/pdf,.doc,.docx" isPublic label="Upload File" onUploaded={load} testid="media-upload-file" />
        </div>
      </div>
      {items.length === 0 && <p className="text-brand-muted text-sm mt-6" data-testid="media-empty">No uploads yet.</p>}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-6">
        {items.map((m) => (
          <div key={m.id} className="card-surface overflow-hidden flex flex-col" data-testid={`media-item-${m.id}`}>
            <div className="aspect-video bg-brand-cream2 flex items-center justify-center overflow-hidden">
              {m.kind === "image" && <img src={mediaUrl(m.url)} alt={m.filename} className="w-full h-full object-cover" />}
              {m.kind === "video" && <video src={mediaUrl(m.url, { auth: true })} controls preload="metadata" className="w-full h-full bg-black" />}
              {m.kind === "file" && <FileText size={36} className="text-brand-sage" />}
            </div>
            <div className="p-3 text-xs flex-1 flex flex-col gap-2">
              <p className="font-medium text-brand-ink truncate" title={m.filename}>{m.filename}</p>
              <p className="text-brand-muted">{(m.size / 1048576).toFixed(1)} MB · {m.kind}</p>
              <div className="flex gap-2 mt-auto">
                <button onClick={() => copy(m)} className="cms-chip !static" data-testid={`media-copy-${m.id}`}><Copy size={12} /> Copy link</button>
                <button onClick={() => togglePublic(m)} className="cms-chip !static" title="Toggle public / members only">{m.public ? <><Globe size={12} /> Public</> : <><Lock size={12} /> Members</>}</button>
                <button onClick={() => del(m)} className="ml-auto text-red-400 hover:text-red-600" data-testid={`media-delete-${m.id}`}><Trash2 size={15} /></button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
